// Why a payroll Net is smaller than the days worked suggest.
//
// Two things reduce it that the daily breakdown cannot show, because neither is
// a property of any single day: the late-coming charge (settled once per month
// against the whole month's count) and the monthly hours shortfall. Before this,
// Payroll Records showed the smaller figure and nothing else — and "why is my
// salary less this month" is the one question a payroll screen must be able to
// answer on its own.
//
// HOLD and DEDUCT are deliberately worded and coloured differently. A hold comes
// back if the next month is clean; a deduction does not. Showing them the same
// way would be the single most misleading thing this component could do.

import type { SalaryRecord } from '../api/salary';

const money = (n: number) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

interface Props {
  record: Pick<SalaryRecord, 'lateComing' | 'hoursShortfall'>;
}

export default function PayDeductionNote({ record }: Props) {
  const late = record.lateComing;
  const hours = record.hoursShortfall;

  const lateCharged = late && late.amount > 0;
  const hoursCharged = hours && hours.amount > 0;
  if (!lateCharged && !hoursCharged) return null;

  return (
    <div className="mt-0.5 space-y-0.5 text-[11px] font-normal leading-tight">
      {lateCharged && (
        <div
          className={late.action === 'deduct' ? 'text-red-600' : 'text-amber-600'}
          title={
            late.action === 'deduct'
              ? `${late.charged_days} × half a day's pay deducted for ${late.late_days} late days`
              : `${late.charged_days} × half a day's pay held for ${late.late_days} late days — returned if next month is clean`
          }
        >
          −{money(late.amount)} late{late.action === 'hold' ? ' (hold)' : ''}
        </div>
      )}
      {hoursCharged && (
        <div className="text-amber-600" title={`${hours.shortfall}h short of ${hours.required}h`}>
          −{money(hours.amount)} hours
        </div>
      )}
    </div>
  );
}
